<template>
  <div class="container">

    <b-row class="ClientViewInfomationBox" position="fixed">
      <b-col cols="2" md="2" sm="2">
        <div class="ikona">
          <i class="fas fa-user" ></i>
        </div>
      </b-col>
      <b-col cols="10" md="10" sm="10">
        <b-row class="b-row-imie-nazw">
          <b-col>
            {{ user.name }} {{ user.surname }}
          </b-col>
        </b-row>
        <b-row class="kolumny">
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Email:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.email }}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Telefon:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.cellphone }}
              </b-col>
            </b-row>
          </b-col>
        <!-- </b-row>
        <b-row class="kolumny"> -->
          <b-col cols="7"md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Adres:
              </b-col>
              <b-col style="margin-block-end:10px">
              {{user.street1}} {{user.building1}} <span v-if="user.flat1">/ {{user.flat1}}</span> <br> {{user.postal_code1}}, {{user.city1}}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Pesel:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.pesel }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>



        <b-row>
          <b-col class="col-12 mb-3">

            <button v-if="nextLoanButton && !toContinue" class=" form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click="nextLoan" >Kolejna Pożyczka</button>


<!--            <button class=" d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click=""  >Zmień numer telefonu</button> -->



            <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doPassChange" >Zmień hasło</button>



            <button v-if="repayLoanButton" class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="payLoan" >Spłać pożyczkę </button>



          </b-col>
        </b-row>


        <p v-if="!nextLoanButton && !repayLoanButton" class="col-10 mx-auto yellow-card"><strong>Aktualnie nie posiadamy dla Ciebie oferty pożyczki. Wróć do nas za {{blockDays}} dni i złóż nowy wniosek. 
          </strong>
        </p>



        <p v-if="showProcessingInfo" class="col-10 mx-auto yellow-card"><strong>Twoja pożyczka została przekazana do wypłaty. Potwierdzenie wypłaty zostanie przesłane drogą email oraz sms. <br>
            W razie jakichkolwiek pytań zapraszamy do kontaktu z naszą infolinią.
          </strong>
        </p>



        <b-row v-if="!parseInt(user.verified)">
          <b-col class="col-12 mb-3 ">


            <p class="col-10 mx-auto yellow-card"><strong>Twoje konto nie zostało zweryfikowane, dokończ proces aby móc złożyć wniosek.
            </strong>
            </p>


            <div class="">

              <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doVerify" >Wyślij SMS</button>
            </div>

          </b-col>
        </b-row>





      </b-col>

    </b-row>
    <b-row>
      <b-col colstyle="border-style:solid; border-width:thin; background-color:whitesmoke">






        <b-table  striped hover :items="getLoansData" :fields="fields"  ref='loans_table' @refreshed="newdata" @row-clicked="clicked" >

          <template #cell(show_details)="row"  >


            <b-button v-if="parseFloat(row.item.to_be_continied)==0" size="sm" @click="row.toggleDetails(); getDocs(row.item.id);" class="mr-2" style="width:40px; background-color:#bababa; margin:0;">


              <i v-if="row.detailsShowing" class="fa fa-minus" />
              <i v-else class="fa fa-plus" />

              <!--
              {{ row.detailsShowing ? 'Pokaż' : 'Ukryj'}} <br> Szczegóły  -->
            </b-button>



            <b-button v-if="parseFloat(row.item.to_be_continied)==1" size="sm" @click="goContinue(row.item.uniqueid, row.item.id);" class="mr-2" style=" background-color:#bababa; margin:0;">

              <i  class="fa fa-edit" /> Dokończ wniosek
                    
            </b-button>


          </template>

          <template #row-details="row" >
            <b-card>

              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Status:</b></b-col>
                <b-col>{{ !!parseInt(row.item.is_closed) ? 'Spłacona' : parseFloat(row.item.status_id) == 1.05 ? 'Wniosek' : 'Aktywna' }}</b-col>
              </b-row>


              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Kwota:</b></b-col>
                <b-col><span >{{ row.item.pay_out_ammount }} PLN</span></b-col>
              </b-row>

              <div v-if="!parseInt(row.item.is_closed)">

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Produkt:</b></b-col>
                  <b-col>{{ row.item.template_name }}</b-col>
                </b-row>
                

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Termin spłaty raty:</b></b-col>
                  <b-col>{{ !!row.item.incoming_payment && row.item.incoming_payment.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1') }}</b-col>
                </b-row>


                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Odbiorca przelewu</b></b-col>
                  <b-col><span  @click="copyToClipboard">MiniCredit sp z o.o.<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>


                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Nr. rachunku do przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard"> {{ row.item.loan_bank_account }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Tytuł przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard">spłata do umowy nr. {{ row.item.contract_nbr }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Aktualna kwota do zapłaty:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ row.item.to_be_paid_now }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Pozostała całkowita kwota do spłaty:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ row.item.to_be_paid }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

              </div>


              <div class="d-flex flex-column">
                <p class="HeaderDoPobrania">Do pobrania :</p>
                  <b-link class="HrefDownload" v-for="item in docData" :key="item.id" @click="download(item.id, item.document_name, row.item.contract_nbr)">
                    <i class="fas fa-download"></i> {{ item.document_name }}
                  </b-link>
              </div>


              <div v-if="parseFloat(row.item.status_id) == 1.05 && showSignature">

                  <h4 class="dark entry-title"> <i class="fas fa-file-signature"></i> Po podpisaniu umowy ostatecznie zweryfikujemy Twój wniosek. </h4>

              
                  <SignContract v-if="showSignature" :loan_id="row.item.id" label="Podpisz Umowę" @consent="consentChange" @signed="signedTerms"/>

              </div>


              <h4 class="dark entry-title" style="color:lemon;"  v-if="showThanks"> <i class="fas fa-check"></i> Dziękujemy za Podpisanie umowy, poinformujemy Cię o wypłacie pożyczki. </h4>


              <h4 class="dark entry-title" style="color:red;" v-if="!!err"> <i class="fas fa-error"></i> {{ err }} </h4>

            </b-card>
          </template>



        </b-table>

      </b-col>
    </b-row>



    <PassChange />


    </div>
</template>

<script>


/*
  //import ZCVB from "./components/ZetosClientViewButtons";
  import __CFG from '@/conf/config.json';


  import axios from 'axios';
  // set to allow session cookies
  axios.defaults.withCredentials = true;
*/


  import PassChange from '@/components/PassChange.vue';
  import SignContract from '@/components/SignContract';

  export default {

    components: {
      SignContract,
      PassChange
    },

    data() {
      return {

        err: '',

        authCode: '',
        loanId: null,

        isSigned: false,
        showThanks: false,
        showSignature: true,




        showProcessingInfo: false,

        toContinue: false,

        goAnotherLoan: false,


        nextLoanButton: false,
        blockDays: 0,
        repayLoanButton: false,

        user: {},


        fields: [


          {
            key: 'show_details', label: '', tdClass: 'd-flex justify-content-left align-middle', thStyle: 'width: 80px;'//,

            /*formatter(value, key, item){


              console.log(item)

            }*/
          },


          {
            key: 'contract_nbr', label: 'Numer Umowy', tdClass: 'align-middle'
          },

          {
            key: 'loan_date', label: 'Data Pożyczki', tdClass: 'align-middle'
          },

          {
            key: 'pay_out_ammount', label: 'Kwota', tdClass: 'align-middle'
          }


        ],

/*
        items: [

        ],*/



        loansData: [],

        docs: []


      };
    },


    computed: {


      docData(){


        let seen = [], docname,


        // first - sort documents by highest id - multiple agreements may occur

        docs = !this.docs ? [] : this.docs.sort( (a,b) => parseInt(b.id) - parseInt(a.id) ).filter( doc => {

          docname = String(doc.document_name).trim();


          return seen.indexOf(docname) == -1 && seen.push(docname);

        });


        //console.log(seen);

        //console.log('seen docs');



        return docs;
      },



      cptItems() {
        return this.items.map((item) => {
          let tmp = item;
          item.do_spłaty > 0 ? item._rowVariant = "" : item._rowVariant = 'success';
          return tmp;
        })
      }



    },
    methods: {

      payLoan(){
          this.get('/p24').then(response=>{


            //console.log(response.data.Message);


              this.log('p24 repay init - redirect to location ', response.data.Message);


              location.href = response.data.Message;

          }).catch(error =>{

            //console.log(error);

            this.toast('pożyczka nie aktywna')
          })
      },


      clicked(row){

        row._showDetails = !row._showDetails;
      },


      newdata(){

///console.log('rows loaded')

//console.log(this.$refs)

      },


      getLoansData (ctx, callback) {


        // load clients contracts
        this.get('/client/loans')

          .then(response => {

            let items = [], first = true;

            if (!response.data) {

              items = [];
            }
            else {


              // lets see if we have some loans under processing
              response.data.map( l => {


                parseFloat(l.status_id) == 1.1 && (this.showProcessingInfo = true);


                // activate repay button if loan found active loan
                !this.repayLoanButton && parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4 && !parseInt(l.is_closed) && (this.repayLoanButton = true);


                // found application to continue
                !this.toContinue && parseFloat(l.to_be_continied) > 0 && (this.toContinue = true);
              });



              items = response.data.filter( l => (parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4) 
                || parseFloat(l.status_id) == 1.05 // docs generated
                || parseFloat(l.status_id) == 1.1 // signed
                || parseFloat(l.to_be_continied)==1 

                ).map( l => {



                if (first && parseFloat(l.to_be_continied)==0) {

                  l._showDetails = first;

                  this.getDocs(l.id);

                  first = false;
                }



                l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

                l.pay_out_ammount = parseInt(l.pay_out_ammount);

                l.contract_nbr += !!parseInt(l.is_closed) && parseInt(l.status_id) > 3 ? ' - spłacona' : parseFloat(l.status_id) == 1.05 ? ' - wniosek' : '';          

                return l;
              })
            }

  //console.log(items);


            callback(items);

          })
          .catch(error => {
            callback([]);
          });


          // Must return null or undefined to signal b-table that callback is being used
          return null
      },



      signDone(){

          this.isSigned = true;
          this.showThanks = true;
      },

      signedTerms(loan_id){


            this.loanId = loan_id;

            this.signTerms();

            
            this.showSignature = false;

      },


      signTerms() {

          var me = this;

          this.patch( '/accept', {
            loan_id: this.loanId 
          })
              .then(response => {


                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);


                  ok && me.signDone();


           //       console.log('acccepted  ')

                }
              })
              .catch(error => {


                me.showSignature = true;

                           // Error
                  if (error.response) {

                    console.log(error.response);


                    this.err = error.response.data.Message || (typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors);

                  }
              });

        },

      consentChange(type, grant){

        let cons = ['first', 2, 'second', 1];


        if (cons.indexOf(type) > -1) {


              this.patch( '/client/consent', {
                consent_id: cons[ cons.indexOf(type) + 1 ],
                consent_bit: grant | 0
              })
                  
                  .then(response => {


                    if (!!response.data) {

                      let ok = !(response.data.IS_ERROR | 0);
                      
                      console.log('consent done  ')
                    }
                  })
                  .catch(error => {

                      // Error
                      if (error.response) {

                        console.log(error.response);

                        //this.err = error.response.data.Message || (typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors);

                      }
                  });

        }




      },


      doPassChange(){

        this.echo('pass_change_dialog');
      },


      doVerify(){


        this.$router.push({path: '/verifycode', query: { do: 'verify'}});

      },


      nextLoan() {


        this.goAnotherLoan = true;      

        this.echo('login_reload');

      },



      download(downloadID, name, contractNbr) {


/*
          this.get('/client/document/' + downloadID, {

            responseType: 'blob'
          })
          .then((response) => {


            var fileURL = window.URL.createObjectURL(new Blob( [response.data] ));
*/

            let fileLink = document.createElement('a');

            fileLink.href = '/api/client/document/' + downloadID; // fileURL;
            fileLink.setAttribute('download', String(name).trim() + ' ' + contractNbr.split('/')[0] + '.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();



        //  });
      },

      getDocs(loanId){

          this.get('/client/documents/' + loanId)


            .then(response => {




              this.docs = !response.data ? [] : response.data.filter( rec => {



                /nowy/i.test(rec.document_name) && (rec.document_name = rec.document_name.replace(/nowy/i, ''));


                return /formularz|umowa/i.test(rec.document_name) && !/wzor|nowa/i.test(rec.document_name);

              });





            //  console.log(this.docData)


            })
            .catch(error => {
              console.log('Network error', error);
            });
      },




      goContinue(uid, loanId) {


        var page = this.$root.mainpage,
            dat,
            step;


            page.isLoading = true;

            this.get('/application/resume/' + uid)

            .then(response => {




              dat = Array.isArray(response.data) && response.data.length > 0 ? {...response.data[0]} : response.data;

              step = dat.hasOwnProperty('step') ? dat.step : '';




              //console.log(response);


              switch (step) {

                case 'wait':
                  break;

                case 'counteroffer':
                  page.isLoading =false;
                  this.$router.push({path: 'proposal'});
                  return;

                case 'transactionlink':

                  // transactionlink workflow token
                  this.get( '/transactionlink/' +  window.__sid )
                  .then(response => {

                    if (!!response.data) {              

                      page.isLoading=false;

                      page.party_id = window.__sid;
                      page.workflow_token = response.data;
                      
                      page.loanId = loanId;
                      
                      this.$router.push({path: 't10l'});
       
                    }
                  })
                  .catch(error => {

                    console.log('workflow token error', error);
                  });

                  return;

                case 'reject':
                    page.isLoading=false;
                    this.$router.push({path: 'rej'});
                    return;


                case 'accept':
                    page.isLoading=false;
                    page.loanId = loanId;
                    this.$router.push({path: 'thankyou'});
                    return;

                                                                  
                default:
                  page.isLoading =false;
                  this.$router.push({path: 'pending'});
                  return;
              }


            })
            .catch(error => {
              console.log('Network error', error);
            });

      }




    },


    created() {



      this.user = JSON.parse(localStorage.getItem('user'));



      // no active loans and no rejections so activate next loan button
      this.nextLoanButton = parseInt(this.user.block_days_left) === 0; //  !parseInt(this.user.rejected_loan_no) && !parseInt(this.user.active_loan_no);

      this.blockDays = this.user.block_days_left;





      this.listen('login_reloaded', () => {

        this.user = JSON.parse(localStorage.getItem('user'));


        if (this.goAnotherLoan) {

          this.goAnotherLoan = false;


          // no blocking so go applicate
          if (parseInt(this.user.block_days_left) === 0) {

            this.$router.push({path: '/fullform'});
          }
          else {

            this.blockDays = parseInt(this.user.block_days_left);
            this.nextLoanButton = false;
          }
        }
      });




/*

      // load clients contracts
      this.get('/client/loans')

        .then(response => {

          //let row = ['contract_nbr', '']


          if (!response.data) {

            this.loansData =  [];
          }
          else {

            this.loansData = response.data;

            this.items = this.loansData.filter( l => (parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4) || parseFloat(l.status_id) == 1.05 ).map( l => {


         //     l._showDetails = true;


              l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

              l.pay_out_ammount = parseInt(l.pay_out_ammount);


              l.contract_nbr += !!parseInt(l.is_closed) && parseInt(l.status_id) > 3 ? ' - spłacona' : parseFloat(l.status_id) == 1.05 ? ' - wniosek' : '';

              // some mods to data


//console.log(l)            

              return l;
            });


          }


console.log(this.$refs['loans_table']);
//console.log(this.items);



//this.$refs['loans_table'].items



        })
        .catch(error => {
          console.log('Network error', error);
        });



*/

    },

    mounted() {



    }
  }
</script>


<style scoped>

  .HeaderDoPobrania{
    margin-block-end:20px;
    font-weight:bold;
  }
  .fa-user {
    font-size: 80px;
    border-radius: 100px;
    box-shadow: 0px 0px 5px white;
    padding: 0.5em 0.6em;
  }


  .ikona {

    margin-top:35px;
    justify-content: center;
    text-align: center;
  }


  .NauClientViewTitle {
    color: #c2c2c2;
  }




  .btn {
    text-decoration-style: solid;
    font-size: 17px;
    width: 230px;

  }
  .HrefDownload{
    margin-block-end:20px;
    color: orange;
  }

  .HrefDownload:hover{
    margin-block-end:20px;
    color: tomato;
  }

  @media (max-width: 575px) {
    .NauClientViewTitle {
      font-size: 15px
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top:1px;
    }
    .fa-user {
      opacity:0;
    }
    .btn {
      color: white;
      text-decoration-style: solid;
      background-color: transparent;
      font-size: 17px;
      width: 230px;
      margin-block-end: 16px;

    }
  }
  @media (max-width: 991px) {
    .NauClientViewTitle {
      font-size: 15px

    }
    .fa-user {
      font-size: 26px;
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top: 10px;
    }
  }
  .b-row-imie-nazw{
    margin-top:.3em;
    font-size: 2.4rem;
    text-decoration-style:solid;
    margin-block-end: 8px;
    text-align:left;
  }
  .kolumny {
    width: 100%;
  }
 .b-col{
   display:flex;
 }


 .copy-icon {

    color: #045439;
    padding-left:1rem;
 }


</style>



// WEBPACK FOOTER //
// src/MCClientView.vue